<section class="ctb-resume" aria-label="Résumé de l'estimation">
	<p class="ctb-resume__price-range">{{ formattedPriceRange() }}</p>

	<p class="ctb-resume__description">{{ state().description }}</p>
</section>
